import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useParamQuery } from 'src/hooks';
import { useDeleteComponentTag } from 'src/hooks/api/componentTags/useDeleteComponentTag';
import { useGetComponentTagWithComponentCount } from 'src/hooks/api/componentTags/useGetComponentTagWithComponentCount';
import { formatQuery, lang } from 'src/utils';

import {
  Column,
  COMPONENT_TAG_LIST_COLUMN,
} from '../ManageComponentTagPage.interface';
import { getTotalLengthPerPage } from '../modules/ManageComponentTag.helper';

export const useManageComponentTagPage = () => {
  const location = useLocation();
  const {
    data: componentTagWithComponentCount,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useGetComponentTagWithComponentCount(formatQuery(location.search));

  const totalCount = componentTagWithComponentCount?.pages?.[0].totalCount || 0;
  const numberofResults = getTotalLengthPerPage(
    componentTagWithComponentCount?.pages ?? [],
  );
  const [activeColumn, setActiveColumn] = useState<string>(
    COMPONENT_TAG_LIST_COLUMN.NAME,
  );

  const [isActive, setIsActive] = useState(false);

  const deleteComponentTag = useDeleteComponentTag();

  const [sorting, setSorting] = useState({
    columnKey: COMPONENT_TAG_LIST_COLUMN.NAME,
    order: 'asc',
  });

  const { activeFilters, onChangeParams } = useParamQuery({
    sort: [COMPONENT_TAG_LIST_COLUMN.NAME],
  });

  const getNextComponentTagWithComponentCountPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage]);

  const handleSort = (columnKey: COMPONENT_TAG_LIST_COLUMN, order: string) => {
    setSorting(() => ({
      columnKey,
      order,
    }));
    setIsActive(true);
    setActiveColumn(columnKey);
    onChangeParams('sort', [
      `${order === 'asc' ? columnKey : `-${columnKey}`}`,
    ]);
  };

  const columns: Column[] = [
    {
      label: lang.componentTag,
      key: COMPONENT_TAG_LIST_COLUMN.NAME,
      sortIcon: true,
    },
    {
      label: lang.numberOfComponents,
      key: COMPONENT_TAG_LIST_COLUMN.COMPONENTS_COUNT,
      sortIcon: true,
    },
    { label: '', key: COMPONENT_TAG_LIST_COLUMN.ACTIONS, sortIcon: false },
  ];

  return {
    componentTagWithComponentCount,
    isLoading,
    hasActiveFilters: !isEmpty(activeFilters),
    getNextComponentTagWithComponentCountPage,
    onChangeParams,
    columns,
    handleSort,
    isActive,
    activeColumn,
    sorting,
    hasNextPage,
    totalCount,
    numberofResults,
    activeFilters,
    deleteComponentTag,
  };
};
